import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { RootState } from '../../store';

const Sidebar = () => {
	const navbar = useLocation();
	const { roleandPermission } = useSelector((state: RootState) => state.auth);

	const activeClass = (url: string) => {
		return navbar.pathname?.includes(url);
	};
	return (
		<aside className='sidebar sidebar-left'>
			<div className='sidebar-content'>
				<div className='sidebar-menu'>
					<ul className='list-unstyled m-0'>
						<li>
							<Link
								to='/my-profile'
								className={activeClass('/my-profile') ? 'active' : ''}
							>
								<i className='icon dripicons-user'></i>
								My Profile
							</Link>
						</li>

						{/* {roleandPermission?.find((data: any) => data?.module?.key == 'geo_fences')
							?.view && (
								<li>
									<Link to='/geofence' className={activeClass('/geofence') ? 'active' : ''}>
										<i className='icons dripicons-location'></i>
										Geofences
									</Link>
								</li>
							)} */}

						{/* <li>
							<Link to='/pricing'>
								<i className='icon dripicons-ticket'></i>
								Pricing
							</Link>
						</li> */}

						{/* {roleandPermission?.find((data: any) => data?.module?.key == 'time_slots')
							?.view && (
							<li>
								<Link
									to='/timeslots'
									className={activeClass('/timeslots') ? 'active' : ''}
								>
									<i className='icons dripicons-clock'></i>
									Time Slots
								</Link>
							</li>
						)} */}

						{/* {roleandPermission?.find((data: any) => data?.module?.key == 'holidays')
							?.view && (
							<li>
								<Link to='/holidays' className={activeClass('/holidays') ? 'active' : ''}>
									<i className='icons dripicons-calendar'></i>
									Holidays
								</Link>
							</li>
						)} */}

						{roleandPermission?.find((data: any) => data?.module?.key == 'sub_admins')
							?.view && (
								<li>
									<Link
										to='/sub-admins'
										className={activeClass('/sub-admins') ? 'active' : ''}
									>
										<i className='icons dripicons-user-group'></i>
										Sub Admins
									</Link>
								</li>
							)}

						<li>
							<Link
								to='/subscription-plan'
								className={activeClass('/subscription-plan') ? 'active' : ''}
							>
								<i className='icons dripicons-calendar'></i>
								Subscription Plans
							</Link>
						</li>

						{roleandPermission?.find(
							(data: any) => data?.module?.key == 'roles_and_permission'
						)?.view && (
								<li>
									<Link
										to='/roles-permissions'
										className={activeClass('/roles-permissions') ? 'active' : ''}
									>
										<i className='icons dripicons-menu'></i>
										Roles & Permissions
									</Link>
								</li>
							)}

						{roleandPermission?.find((data: any) => data?.module?.key == 'notifications')
							?.view && (
								<li>
									<Link
										to='/notifications'
										className={activeClass('/notifications') ? 'active' : ''}
									>
										<i className='icons dripicons-bell'></i>
										Notifications
									</Link>
								</li>
							)}

						{roleandPermission?.find((data: any) => data?.module?.key == 'app_settings')
							?.view && (
								<li>
									<Link
										to='/app-settings'
										className={activeClass('/app-settings') ? 'active' : ''}
									>
										<i className='icons dripicons-gear'></i>
										App Settings
									</Link>
								</li>
							)}

						{roleandPermission?.find(
							(data: any) => data?.module?.key == 'email_templates'
						)?.view && (
								<li>
									<Link
										to='/email-templates'
										className={activeClass('/email-templates') ? 'active' : ''}
									>
										<i className='icons dripicons-mail'></i>
										Email Templates
									</Link>
								</li>
							)}

						{roleandPermission?.find((data: any) => data?.module?.key == 'cms_pages')
							?.view && (
								<li>
									<Link to='/cms' className={activeClass('/cms') ? 'active' : ''}>
										<i className='icons dripicons-document'></i>
										CMS
									</Link>
								</li>
							)}

						{/* <li>
							<Link
								to='/settlement'
								className={activeClass('/settlement') ? 'active' : ''}
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='16'
									height='16'
									fill='currentColor'
									className='bi bi-cash-coin me-3'
									viewBox='0 0 16 16'
								>
									<path
										fillRule='evenodd'
										d='M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z'
									/>
									<path d='M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z' />
									<path d='M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z' />
									<path d='M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z' />
								</svg>
								Settlement
							</Link>
						</li> */}
						{/* {roleandPermission?.find((data: any) => data?.module?.key == 'contact_us')
							?.view && (
								<li>
									<Link
										to='/contact-us'
										className={activeClass('/contact-us') ? 'active' : ''}
									>
										<i className='icons dripicons-question'></i>
										Contact Us
									</Link>
								</li>
							)} */}
					</ul>
				</div>
			</div>
		</aside>
	);
};

export default Sidebar;
